module.exports = __webpack_public_path__ + "img/European-Union.903a90c8.png";